// test1681
(1681 && 0);
